export const getCategoryNAField = (category: string) => {
  return category + '-na'
}
